import React, { useState } from 'react';
import ExperienceFilter from './ExperienceFilter';
// import BudgetFilter from './BudgetFilter';
import StyledCard from '../Cards/StyledCard';
import { useAuthContext } from '../../context/AuthProvider';
import { CheckboxGroup } from '../Checkboxes/CheckboxGroup';
import IconWrapper from '../Cards/IconWrapper';
import { CircleSlash2, ClockArrowUp, ClockFading, GraduationCap, Handshake, Hourglass } from 'lucide-react';
import { hasPermission, PERMISSIONS } from '../../config/permissions.config';
import { getJobProfileAsOptions } from '../../config/jobprofile.config';

// Hidden for now. Add handleBudgetFilter back to the props to show the budget filter again.
const Filters = ({ filters = {}, handleCheckboxChange, activeTab, handleExperienceFilter, clearAllFilters }) => {
    const isDisabled = activeTab === 'draft';
    const [shouldResetExperience, setShouldResetExperience] = useState(false);
    // const [shouldResetBudget, setShouldResetBudget] = useState(false);

    const { user } = useAuthContext();
    const role = user?.role || 'Candidate'; // Default to Candidate if role is not specified

    const jobTypeOptions = [
        {
            value: 'Full Time',
            label: 'Full-time',
            icon: {
                active: () => <IconWrapper size={0} inheritColor  icon={ClockArrowUp} customIconSize={6} isActiveIcon />,
                inactive: () => <IconWrapper size={0} inheritColor icon={ClockArrowUp} customIconSize={6} isInActiveIcon />
            }
        },
        {
            value: 'Contract',
            label: 'Contract',
            icon: {
                active: () => <IconWrapper size={0} inheritColor icon={Hourglass} customIconSize={6} isActiveIcon />,
                inactive: () => <IconWrapper size={0} inheritColor icon={Hourglass} customIconSize={6} isInActiveIcon />
            }
        },
        {
            value: 'Internship',
            label: 'Intern',
            icon: {
                active: () => <IconWrapper size={0} inheritColor icon={GraduationCap} customIconSize={6} isActiveIcon />,
                inactive: () => <IconWrapper size={0} inheritColor icon={GraduationCap} customIconSize={6} isInActiveIcon />
            }
        },
        ...(hasPermission(role,PERMISSIONS.SHOW_FILTER_PART_TIME) ? [{
            value: 'Part Time',
            label: 'Part-time',
            icon: {
                active: () => <IconWrapper size={0} inheritColor icon={ClockFading} customIconSize={6} isActiveIcon />,
                inactive: () => <IconWrapper size={0} inheritColor icon={ClockFading} customIconSize={6} isInActiveIcon />
            }
        }] : []),
    ];

    const jobProfileOptions = getJobProfileAsOptions();

    const closedOptions = [
        {
            value: 'Hired', label: 'Hired', icon: {
                active: () => <IconWrapper size={0} inheritColor icon={Handshake} customIconSize={6} isActiveIcon />,
                inactive: () => <IconWrapper size={0} inheritColor icon={Handshake} customIconSize={6} isInActiveIcon />
            }
        },
        {
            value: 'NotHired', label: 'Not Hired', icon: {
                active: () => <IconWrapper size={0} inheritColor icon={CircleSlash2} customIconSize={6} isActiveIcon />,
                inactive: () => <IconWrapper size={0} inheritColor icon={CircleSlash2} customIconSize={6} isInActiveIcon />
            }
        }
    ];
    const handleExperienceApply = (experience) => {
        setShouldResetExperience(false);
        handleExperienceFilter(experience);
    };

    // const handleBudgetApply = (budget) => {
    //     setShouldResetBudget(false);
    //     handleBudgetFilter(budget);
    // };

    const handleClearAll = () => {
        clearAllFilters();
        setShouldResetExperience(true);
        // setShouldResetBudget(true);
    };


    return (
            <StyledCard padding={2} backgroundColor={'bg-background-100'} extraStyles={"relative md:w-full"}>
                <h3 className='text-font-main   mb-2  tracking-wide' >Filter</h3>
                <div className='flex flex-row-reverse absolute top-5 right-5'>
                    <button
                        onClick={handleClearAll}
                        className="text-font-teritiary typography-small-p hover:text-font-accent "
                    >
                        Clear All
                    </button>
                </div>
                {activeTab === 'closed' && (
                    <CheckboxGroup
                        title="Job Status"
                        options={closedOptions}
                        filters={filters.closingStatus || []}
                        handleCheckboxChange={(value) => handleCheckboxChange('closingStatus', value)}
                        isDisabled={isDisabled}
                        useCustomIconCheckbox={true}
                    />
                )}

                <CheckboxGroup
                    title="Employment Type"
                    options={jobTypeOptions}
                    filters={filters.employmentType || []}
                    handleCheckboxChange={(value) => handleCheckboxChange('employmentType', value)}
                    isDisabled={isDisabled}
                    useCustomIconCheckbox={true}
                />

                <CheckboxGroup
                    title="Job Profile"
                    options={jobProfileOptions}
                    filters={filters.jobProfile || []}
                    handleCheckboxChange={(value) => handleCheckboxChange('jobProfile', value)}
                    isDisabled={isDisabled}
                />

                <div className="mb-6">
                <p className="typography-body  text-font-main mb-2">Experience Filter</p>
                    <ExperienceFilter
                        onApply={handleExperienceApply}
                        shouldReset={shouldResetExperience}
                    />
                </div>

                {/* Hidden for now. Uncomment to show the budget filter again.
                <div>
                    <p className="typography-body text-font-main  mb-2">Budget Filter</p>
                    <BudgetFilter 
                        onApply={handleBudgetApply}
                        shouldReset={shouldResetBudget}
                    />
                </div>
                */}

            </StyledCard>
    );
};

export default Filters;
